import useWinQuotePriceMutation from "@/common/api/mutation/quoteMutations/useWinPriceQuote.mutation";
import { useModal } from "@/common/contexts/Modal.context";
import { useGenerateFormElements } from "@/common/hooks";
import { FormFieldsStrategyType } from "@/common/types";
import { Button, Form, message } from "antd";
import GoToPageButton from "../ActionsButtons/GoToPageButton";
import StayInPageButton from "../ActionsButtons/StayInPageButton";
import InfoModal from "./Info.modal";
import { usePermissions } from "@/common/contexts/Permissions.context";
const editableStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    name: "targetOTC",
    label: "Target OTC",
    required: true,
    pattern: /^[0-9]*$/,
    patternMessage: "Only numeric value available",
  },
  {
    inputType: "text",
    name: "targetMRC",
    label: "Target MRC",
    required: true,
    pattern: /^[0-9]*$/,
    patternMessage: "Only numeric value available",
  },
];

export default function WinPriceModal({ data }: { data: any }) {
  const { closeModal, openModal } = useModal();
  const [form] = Form.useForm();
  const { company } = usePermissions();
  const quoteReqId = data.quoteReqId;
  const vendorId = data?.price?.companyId;
  const quoteLineId = data.id;
  const externalSubmit = () => {
    form.submit();
  };
  const { mutate } = useWinQuotePriceMutation();
  const onFinish = (values: any) => {
    if (!quoteReqId || !vendorId || !quoteLineId) {
      return message.error(
        "Something went wrong. Please reopen this modal or pick another option."
      );
    }
    const generateWinPriceData = {
      quoteLineId,
      vendorId,
      quoteReqId,
      targetMRC: Number(values.targetMRC),
      targetOTC: Number(values.targetOTC),
    };
    mutate(generateWinPriceData, {
      onSuccess: () => {
        closeModal();
        openModal(
          <InfoModal
            instruction={{
              behavior: "success",
              description: "",
              header: "Quote created",
            }}
            actions={[
              <StayInPageButton />,
              <GoToPageButton
                destinationName="Go to Quotes"
                link={
                  company.companyType === "customer"
                    ? "/customer/quotes/me"
                    : "/quotes"
                }
              />,
            ]}
          />
        );
      },
    });
  };

  const { formElements: editableFields } =
    useGenerateFormElements(editableStrategy);
  return (
    <div className="flex flex-col gap-5">
      <div>
        <Form form={form} onFinish={onFinish}>
          <div className="flex flex-col gap-4">
            <div className="flex gap-4">{...editableFields}</div>
          </div>
        </Form>
      </div>
      <div className="flex justify-between gap-4">
        <Button
          onClick={() => closeModal()}
          className="text-base font-inter font-semibold h-10"
        >
          Back
        </Button>
        <Button
          onClick={externalSubmit}
          type="primary"
          className="text-base font-inter font-semibold h-10"
        >
          Send Custom Quote
        </Button>
      </div>
    </div>
  );
}
